import { FormControlProps, SelectProps, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import * as React from 'react';
import styled from 'styled-components';
import { SelectButtonOption } from './SelectButtonOption';

const StyledSelect = styled(Select)<SelectProps & { $minWidth?: number }>`
    ${props => (props.$minWidth ? `min-width: ${props.$minWidth}px;` : '')}
`;

export type SelectButtonProps = Pick<FormControlProps, 'style' | 'variant'> & {
    children?: React.ReactNode[];
    dataCy?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    minWidth?: number;
    primaryText?: React.ReactNode;
    secondaryText?: React.ReactNode;
};

export function SelectButton({
    children,
    dataCy,
    fullWidth,
    minWidth = 120,
    primaryText,
    secondaryText,
    ...props
}: SelectButtonProps): JSX.Element {
    return (
        <FormControl fullWidth={fullWidth} {...props}>
            {primaryText && <InputLabel shrink={!!secondaryText}>{primaryText}</InputLabel>}
            <StyledSelect
                $minWidth={minWidth}
                autoWidth
                data-cy={dataCy}
                disabled={props.disabled}
                displayEmpty
                value=""
            >
                {secondaryText && (
                    <MenuItem disabled value={secondaryText ? '' : undefined}>
                        {secondaryText}
                    </MenuItem>
                )}
                {children}
            </StyledSelect>
        </FormControl>
    );
}
SelectButton.displayName = 'SelectButton';
SelectButton.SelectButtonOption = SelectButtonOption;
